import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from "lodash";
export default class AcuseCompra {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data, mainData.total);

    let imgColumn = {
      // star-sized columns fill the remaining space
      // if there's more than one star-column, available width is divided equally

      text: "",
      width: "10%",
    };
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      pageOrientation: "portrait",
      content: [
        //header
        {
          columns: [
            {
              // fixed width
              width: "100%",
              alignment: "center",
              bold: true,
              text: [mainData.TITLE + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: [
                "FECHA: " + mainData.FI + "\n",
                "DESC: " + (mainData.dsc || "Descripción no disponible") + "\n",
              ],
            },
            {
              // fixed width
              width: "35%",
              alignment: "left",
              bold: true,
              text: [
                "ALMACEN: " +
                  (mainData.origen || "Almacén no disponible") +
                  "\n",
                "DEPTO: " +
                  (mainData.dpt || "Departamento no disponible") +
                  "\n",
              ],
            },
            {
              // % width
              width: "30%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora Generado: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              width: "100%",
              alignment: "left",
              fontSize: 13,
              text: ["\n" + (mainData.nts || "") + "\n"],
            },
          ],
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: ["*", "auto", "auto", "auto"],
                heights: 25,
                body: getTable,
              },
            },
          ],
          margin: [0, 10, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data, Total) {
    // Encabezados de la tabla
    let headers = [
      { text: "Producto", border: [true, true, true, true], fontSize: 12 },
      { text: "Cantidad", border: [true, true, true, true], fontSize: 12 },
      { text: "Total", border: [true, true, true, true], fontSize: 12 },
      { text: "Precio", border: [true, true, true, true], fontSize: 12 },
    ];

    let tables = [];

    // Iterar sobre cada grupo de productos por proveedor en `data`
    data.forEach((grupo) => {
      // Añadir el nombre del proveedor como una fila separada
      tables.push([
        {
          text: grupo.proveedor,
          bold: true,
          fontSize: 14,
          colSpan: 3,
          alignment: "center",
        },
        {},
        {},
        {},
      ]);

      // Añadir cada producto del grupo como una fila
      grupo.items.forEach((prod) => {
        // console.log(prod.producto.nombre);
        tables.push([
          {
            text:
              (prod.producto.nombre ? prod.producto.nombre : "Sin nombre") +
              " - " +
              (prod.presentacion ? prod.presentacion.nom : "Sin presentación") +
              "\n Rendimiento: " +
              prod.rdm +
              " " +
              (prod.producto?.unidadMedida || "PZA"),
            border: [true, true, true, true],
            fontSize: 12,
          },

          {
            text: pgsHelper.formatNumber(prod.cnt || 0),
            border: [true, true, true, true],
            fontSize: 12,
          },
          {
            text:
              prod.cnt * prod.rdm +
              " " +
              (prod.producto?.unidadMedida || "PZA"),
            border: [true, true, true, true],
            fontSize: 12,
          },
          {
            text:
              pgsHelper.formatNumber(prod.pcu.C || 0) +
              " " +
              (prod.pcu.M || "MXN"),
            border: [true, true, true, true],
            fontSize: 12,
          },
        ]);
      });
    });
    tables.push([
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 8,
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 8,
      },
      {
        text: "",
        border: [true, true, true, true],
        fontSize: 8,
      },
      {
        text: "Total: $" + Total,
        border: [true, true, true, true],
        colSpan: 1,
        fontSize: 12,
      },
    ]);

    return [headers, ...tables];
  }

  // static getFirmas(data, porcentaje) {
  //   let times = [
  //     [
  //       { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
  //       { text: "Total", border: [true, true, true, true], fontSize: 12 },
  //       {
  //         text: "%" + porcentaje,
  //         border: [true, true, true, true],
  //         fontSize: 12,
  //       },
  //       { text: "Firma", border: [true, true, true, true], fontSize: 12 },
  //     ],
  //   ];
  //   data.forEach((venta) => {
  //     let rowToAdd = [];
  //     if (venta.tipo == "footer") {
  //       rowToAdd = [
  //         {
  //           text: venta.Mesero,
  //           border: [true, true, true, true],
  //           fontSize: 10,
  //         },
  //         {
  //           text: "$" + pgsHelper.formatNumber(venta.Total),
  //           bold: true,
  //           border: [true, true, true, true],
  //           fontSize: 10,
  //           alignment: "right",
  //         },
  //         {
  //           text:
  //             "$" +
  //             pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
  //           bold: true,
  //           border: [true, true, true, true],
  //           fontSize: 10,
  //           alignment: "right",
  //         },
  //         {
  //           text: " ",
  //           bold: true,
  //           border: [true, true, true, true],
  //           fontSize: 10,
  //           alignment: "center",
  //         },
  //       ];
  //       times.push(rowToAdd);
  //     }
  //   });

  //   let table = {
  //     border: [true, false, true, true],
  //     widths: ["*"],
  //     heights: 60,
  //     table: {
  //       body: times,
  //     },
  //   };

  //   return times;
  // }
}
